export const S3_BASE = 'https://incubator-0.s3.amazonaws.com/nhattonnhulaitang';
